import React from 'react'
import BannerBrandImageSection from '../../../bannerBrandImageSection'
import { ISettlementStageProps } from './interfaces/ISettlementStageProps'
import globals from 'application/constants/globals'
import { HomeStaticData } from './../homeStaticData'
import { useSelector } from 'react-redux'

const SettlementStage = (props: ISettlementStageProps) => {
  const { firstName, vehicleDescription, proposalLink, settlementLink } = props

  let settlementComplete = useSelector(
    (state: any) =>
      state.opportunity.settlement &&
      state.opportunity.settlement.isValid &&
      state.opportunity.settlement.recipients &&
      state.opportunity.settlement.recipients.filter(
        (r: any) => !r.hasSigned
      ) === 0
  )

  const sectionTitle = globals.isBrandMX
    ? `It's time for the final step of approval ${firstName}!`
    : `It's time for the final step ${firstName}!`

  const firstButton = {
    buttonName: 'Sign my documents',
    disabled: false,
    linkUrl: settlementLink,
  }
  const secondButton = {
    buttonName: 'View my proposal again',
    disabled: false,
    linkUrl: proposalLink,
  }
  const bannerArgs = {
    vehicleDescription: vehicleDescription,
  }

  return (
    <>
      <BannerBrandImageSection
        id="maincontent"
        bannerImageName={
          globals.isBrandMX && !settlementComplete ? 'Banner1' : undefined
        }
        imageText={
          settlementComplete
            ? 'Congratulations ' + firstName
            : 'The wheels are in motion!'
        }
        sectionContent={HomeStaticData('SettlementBannerText', bannerArgs)}
        sectionTitle={sectionTitle}
        firstButton={firstButton}
        secondButton={secondButton}
      ></BannerBrandImageSection>
    </>
  )
}

export default SettlementStage
